/* eslint-disable */
import { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import ReactToPrint from 'react-to-print';
import { Row, Col } from 'react-bootstrap';
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";

import { CardContent, Modal } from '@mui/material';
import { TextField } from '@mui/material';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { getMaintenanceCheckupItemsByQuery } from 'components/axios/maintenanceCheckupItemsAxios';
import { deleteMaintenanceCheckupResults, getMaintenanceCheckupResultsById, getMaintenanceCheckupResultsByQueryString, patchMaintenanceCheckupResults, postMaintenanceCheckupResults } from 'components/axios/maintenanceAxios';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import PdfLayer from 'components/layer/PdfLayer';
import CustomDatePicker from 'components/date_picker/CustomDatePicker';
import EquipmentChecklistExcelDownload from 'components/EquipmentChecklistExcelDownload';
import MainCard from 'components/MainCard';

const EquipmentChecklistLayer = ({info}) => {
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, role } = useEnumApi();
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');
    
    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true); setIsLoading(false); };
    const handleClose = () => setOpen(false);

    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const [checkupId, setCheckupId] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [checkCycle, setCheckCycle] = useState('');

    const [checkupItems, setCheckupItems] = useState(null);
    const [checkupResults, setCheckupResults] = useState(null);

    const [excelDatas1, setExcelDatas1] = useState([]);
    const [excelDatas2, setExcelDatas2] = useState([]);
    const [fileName, setFileName] = useState("");

    const printRef = useRef(null);
    const { control, register, handleSubmit, reset, setValue } = useForm({});
    
    useEffect(()=>{
      if (checkupId) {
        resultList();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[checkupId]);

    const resultList = () => {
      getMaintenanceCheckupResultsById(checkupId).then((data)=>{
        // console.log(data);
        setCheckCycle(data.chkCycle);
        //setCheckupResult(data);
        setValue("chkUser", (data.chkUser || ''));
        setValue("chkYmd", (data.chkYmd || ''));
        setItems(data.chkRslts);

        setFileName(info?.name+"_"+t('message.common.title.maintenance.checklist')+"_" + Date.now());
        setExcelDatas1([t('message.common.subtitle.fieldChkUser'), data.chkUser, '', t('message.common.subtitle.inspection.date'), (data.chkYmd || ''), '', '', t('message.common.subtitle.installation.location')+'(No.)', '', info?.location, '', '']);

        let excelDatas2 = [
          [t('message.common.subtitle.inspection.item'),t('message.common.subtitle.inspection.details'),'', '', t('message.common.subtitle.inspection.cycle'),'','','','','', t('message.common.subtitle.inspection.result'), t('message.common.subtitle.remark')],
          ['','','', '', t('message.common.select.daily'),t('message.common.select.weekly'),t('message.common.select.monthly'),t('message.common.select.quarter'),t('message.common.select.half.year'),t('message.common.select.years'), '', '']
        ];
        const data2 = data.chkRslts;
        if (data2 != null && data2.length > 0) {
          let excelData2 = [];
          data2.map((item, i)=>{
            // console.log(item)
            if (item.rslt != null && item.rslt != '' && item.rslt != 'N') {
              excelData2 = [];
              excelData2.push(item.chkItemNm);
              excelData2.push(item.chkItemDtlNm);
              excelData2.push('');
              excelData2.push('');

              excelData2.push((item.chkCycle === 'D' ? "O" : ""));
              excelData2.push((item.chkCycle === 'W' ? "O" : ""));
              excelData2.push((item.chkCycle === 'M' ? "O" : ""));
              excelData2.push((item.chkCycle === 'Q' ? "O" : ""));
              excelData2.push((item.chkCycle === 'H' ? "O" : ""));
              excelData2.push((item.chkCycle === 'Y' ? "O" : ""));

              excelData2.push(getEnumValueByEnumName("CheckResult").find(cycle=>cycle.code==item.rslt).title);
              excelData2.push('');

              excelDatas2.push(excelData2);
            }
          })
        }
        setExcelDatas2(excelDatas2);
      }).then((res)=>{
      });
    }

    const checkList = () => {
      if (info.equipmentCtgr) {
        let param = {"equipmentCtgr.id":info.equipmentCtgr.parent.id, chkItemType:"M", size:50, sort:"id,asc"};
        if (checkCycle) {
          param.chkCycle = checkCycle;
        }
        getMaintenanceCheckupItemsByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.maintenanceCheckupItem;
            if (list) {
              resetItems(list);
            } else {
              setCheckupItems(null);
            }
          } else {
            setCheckupItems(null);
          }
        })
      } else {
        setCheckupItems(null);
      }
    }

    const toDate = new Date();
    const [curMonthStr, setCurMonthStr] = useState(dayjs(toDate).format("YYYY-MM"));
    const [curMonth, setCurMonth] = useState(toDate);
    let firstDate = null;
    let lastDate = null;

    useEffect(()=>{
      //console.log(curMonth);
      //console.log(firstDate);
      //console.log(lastDate);
      Promise.all([
        setMonth()
      ]).then((res)=>{
        checkResultList();
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [curMonth]);

    useEffect(() => {
      if (!isLoading) {
        if (checkupId) {
          // console.log('modify');
          Promise.all([
            setCheckupItems([]),
            resultList(),
            checkList(),
            checkResultList()
          ]).then((res)=>{
            setIsLoading(true);
          })
        } else {
          // console.log('write');
          Promise.all([
            setCheckupItems([]),
            checkList(),
            checkResultList()
          ]).then((res)=>{
            setIsLoading(true);
          })
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkCycle, isLoading]);
    
    const setMonth = () => {
      //console.log(curMonth);
      if (curMonth) {
        setCurMonthStr(dayjs(curMonth).format("YYYY-MM"));
        firstDate = new Date(curMonth.getFullYear(), curMonth.getMonth(),1);
        lastDate = new Date(curMonth.getFullYear(), curMonth.getMonth()+1,0);
      }
    }

    const prevMove = () => {
      // new Date(toDate.setMonth(toDate.getMonth()-1))
      setCurMonth(new Date(curMonth.setMonth(curMonth.getMonth()-1)));
    }

    const nextMove = () => {
    // new Date(toDate.setMonth(toDate.getMonth()+1))
      setCurMonth(new Date(curMonth.setMonth(curMonth.getMonth()+1)));
    }

    const checkResultList = () => {
      // console.log(firstDate);
      // console.log(lastDate);

      let param = "?size=50&equipment.id="+info.id;
      if (firstDate && lastDate)
        param += "&chkYmd=gte("+dayjs(firstDate).format("YYYY-MM-DD")+")&chkYmd=and(lte("+dayjs(lastDate).format("YYYY-MM-DD")+"))";
      // console.log(param);
      getMaintenanceCheckupResultsByQueryString(param).then((data)=>{
        //console.log(data);
        if (data && data._embedded) {
          const list = data._embedded.maintenanceCheckupResults;
          if (list) {
            setCheckupResults(list);
          } else {
            setCheckupResults(null);
          }
        } else {
          setCheckupResults(null);
        }
      })
    }

    const onSubmit = (data, e) => {
      e.preventDefault();
      console.log(data);

      if (!checkCycle) {
        //console.log('chkCycle error');
        alertMessage = t('message.common.alert.division.select');
        setAlertMessage(alertMessage);
        handleAlertClick();
        return;
      }
      
      if (!data.chkUser) {
        //console.log('chkUser error');
        alertMessage = t('message.common.alert.inspector.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        return;
      }

      if (data.chkYmd == null || data.chkYmd == '') {
        //console.log('chkYmd error');
        alertMessage = t('message.common.alert.inspection.date.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        return;
      }
      if (data.chkYmd != null && data.chkYmd != '' && !regexDate.test(data.chkYmd)) {
          alertMessage = t('message.common.alert.inspection.date.input');
          setAlertMessage(alertMessage);
          handleAlertClick();
          return;
      }

      for (var i=0;i<radioValues.length;i++) {
        if (!radioValues[i]) {
          //console.log('radioValues error');
          alertMessage = t('message.common.alert.inspection.result.select');
          setAlertMessage(alertMessage);
          handleAlertClick();
          return true;
        }
      }
      
      let body = {
        chkYmd : data.chkYmd,
        chkUser : data.chkUser,
        chkCycle : checkCycle,
        chkType : "M",
        equipment : {
          id : info.id
        }
      }

      if (ids && ids.length > 0) {
        let chkRslts = [];
        ids.map(function(item,i) {
          let chkRslt = {
            "id": item,
            "chkCycle": chkCycles[i],
            "chkItemDtlNm": dtlNms[i],
            "chkItemNm": nms[i],
            "remark": remarks[i],
            "rslt": radioValues[i]
          }
          chkRslts.push(chkRslt);
        })
        body.chkRslts = chkRslts;
      }

      //console.log(body);

      if (checkupId) {
        //console.log('..... modify ....');
        body.id = checkupId;
        //console.log(body);
        setCheckupId('');
        openModal(modals.confirmModal, {
          onSubmit : (value) => {
            patchMaintenanceCheckupResults(body).then((res)=>{
              alertMessage = t('message.common.alert.modify.done');
              setAlertMessage(alertMessage);
              handleAlertClick();
              setCheckupId(body.id);
              //setIsLoading(false);
              reset();
            }).catch((err) => {
              //console.log(err);
              if (!err.response?.data?.message) {
                alertMessage = err.message;
                setAlertMessage(alertMessage);
                handleAlertClick();
              } else if (err.response.data.message) {
                alertMessage = err.response.data.message;
                setAlertMessage(alertMessage);
                handleAlertClick();
              }
            });
          },
          onClose : () => {
              console.log('close');
          },
          message: t('message.common.alert.modify.question'),
        });
      } else {
        //console.log('..... write ....');
        openModal(modals.confirmModal, {
          onSubmit : (value) => {
            postMaintenanceCheckupResults(body).then((res)=>{
              alertMessage = t('message.common.alert.write.done');
              setAlertMessage(alertMessage);
              handleAlertClick();
              setCheckCycle('');
              resetItems([]);
              checkList();
              setIsLoading(false);
              reset();
            }).catch((err) => {
              //console.log(err);
              if (!err.response?.data?.message) {
                alertMessage = err.message;
                setAlertMessage(alertMessage);
                handleAlertClick();
              } else if (err.response.data.message) {
                alertMessage = err.response.data.message;
                setAlertMessage(alertMessage);
                handleAlertClick();
              }
            });
          },
          onClose : () => {
              console.log('close');
          },
          message: t('message.common.alert.write.question'),
        });
      }
    }
    
    const [ids, setIds] = useState([]);
    const [chkCycles, setChkCycles] = useState([]);
    const [dtlNms, setDtlNms] = useState([]);
    const [nms, setNms] = useState([]);
    const [radioValues, setRadioValues] = useState([]);
    const [remarks, setRemarks] = useState([]);

    const resetItems = (list) => {
      //console.log('resetItems');
      ids.length = 0;
      chkCycles.length = 0;
      dtlNms.length = 0;
      nms.length = 0;
      radioValues.length = 0;
      remarks.length = 0;
      let idsCopy = [...ids];
      let chkCyclesCopy = [...chkCycles];
      let dtlNmsCopy = [...dtlNms];
      let nmsCopy = [...nms];
      let radioValuesCopy = [...radioValues];
      let remarksCopy = [...remarks];
      list.map(function(item,i) {
        //console.log(i,item);
        idsCopy[i] = item.id;
        chkCyclesCopy[i] = item.chkCycle;
        dtlNmsCopy[i] = item.chkItemDtlNm;
        nmsCopy[i] = item.chkItemNm;
        radioValuesCopy[i] = null;
        remarksCopy[i] = null;
        //setValue("rslt_"+i, '');
      })
      setIds(idsCopy);
      setChkCycles(chkCyclesCopy);
      setDtlNms(dtlNmsCopy);
      setNms(nmsCopy);
      setRadioValues(radioValuesCopy);
      setRemarks(remarksCopy);

      setCheckupItems(list);
    }
    
    const setItems = (list) => {
      // console.log('setItems');
      ids.length = 0;
      chkCycles.length = 0;
      dtlNms.length = 0;
      nms.length = 0;
      radioValues.length = 0;
      remarks.length = 0;
      let idsCopy = [...ids];
      let chkCyclesCopy = [...chkCycles];
      let dtlNmsCopy = [...dtlNms];
      let nmsCopy = [...nms];
      let radioValuesCopy = [...radioValues];
      let remarksCopy = [...remarks];
      setIds(idsCopy);
      setChkCycles(chkCyclesCopy);
      setDtlNms(dtlNmsCopy);
      setNms(nmsCopy);
      setRadioValues(radioValuesCopy);
      setRemarks(remarksCopy);
      list.map(function(item,i) {
        //console.log(i,item);
        idsCopy[i] = item.id;
        chkCyclesCopy[i] = item.chkCycle;
        dtlNmsCopy[i] = item.chkItemDtlNm;
        nmsCopy[i] = item.chkItemNm;
        radioValuesCopy[i] = item.rslt;
        remarksCopy[i] = item.remark;
        //setValue("rslt_"+i, item.rslt);
      })
      
      setIds(idsCopy);
      setChkCycles(chkCyclesCopy);
      setDtlNms(dtlNmsCopy);
      setNms(nmsCopy);
      setRadioValues(radioValuesCopy);
      setRemarks(remarksCopy);
         
      setCheckupItems(list);
    }

    const delBtnClick = () => {
      //console.log('delete');
      //console.log(checkupId);

      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          deleteMaintenanceCheckupResults(checkupId).then((data)=>{
            alertMessage = t('message.common.alert.delete');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setCheckupId(null);
            setCheckCycle('');
            setValue("chkUser", '');
            setValue("chkYmd", dayjs(new Date()).format("YYYY-MM-DD"));
            setIsLoading(false);
          }).catch((err)=>{
            console.log(err);
            if (!err.response?.data?.message) {
              alertMessage = err.message;
              setAlertMessage(alertMessage);
              handleAlertClick();
            } else if (err.response.data.message) {
              alertMessage = err.response.data.message;
              setAlertMessage(alertMessage);
              handleAlertClick();
            }
          });
        },
        onClose : () => {
          console.log('close');
        },
        message: t('message.common.alert.delete.question'),
       });
    }

    return (
      <>
        <Button variant="contained" onClick={handleOpen} style={{minWidth:"unset"}}>
          {t('message.common.btn.checklist')}
        </Button>

        <Modal className="pop_box pop_box4" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <MainCard title="" modal darkTitle content={false} style={{width:"1500px"}}>
            <div style={{marginRight:"12px", textAlign:"right"}}>
              <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                {t('message.common.btn.close')}
              </Button>
            </div>
            <CardContent>
                <div style={{maxWidth:"400px", margin:"0 auto 10px auto", textAlign:"center"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
                  <Chip label={`[${info && info.name} (${info && info.equipmentNo}) ${t('message.common.title.maintenance.checklist')}]`} color="primary" style={{maxWidth:"400px"}}/>
                </div>

                <Row className='maint_tabs_cont maint_check_cont'>
                  {/* 수정 */}
                  {checkupId && 
                  <Col sm={8} style={{padding:"10px"}}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div style={{color:"red",fontWeight:"bold"}}>* {t('message.common.alert.division.select')}</div>
                    <div ref={ printRef }>
                    <TableContainer>
                      <Table sx={{ minWidth: 400 }} aria-label="simple table">
                        <TableBody>
                          <TableRow>
                            <TableCell className="th" align="center" style={{border:"1px solid #f0f0f0", height:"60px"}}>{t('message.common.select.division')}</TableCell>
                            <TableCell className='td_print' align="center" style={{border:"1px solid #f0f0f0"}}>
                              <FormControl sx={{ m: 1, minWidth: 100 }}>
                                <CustomEnumSelect
                                  key={checkCycle}
                                  label={t('message.common.select.division')}
                                  labelName={t('message.common.select.division')}
                                  name={'chkCycle'}
                                  defaultValue={checkCycle}
                                  className='td_print'
                                  onChange={(e)=>{
                                    setCheckCycle(e.target.value);
                                    setCheckupId(null);
                                    setIsLoading(false);
                                  }}
                                  list={getEnumValueByEnumName("CheckCycle")}
                                />
                              </FormControl>
                            </TableCell>
                            <TableCell className="th" align="center" style={{border:"1px solid #f0f0f0"}}>{t('message.common.subtitle.fieldChkUser')}</TableCell>
                            <TableCell className='td_print' align="center" style={{border:"1px solid #f0f0f0"}}>
                              <TextField id="outlined-basic" 
                                defaultValue={''}
                                {...register("chkUser", {
                                })} 
                                sx={{ minWidth: '80%', backgroundColor: "#fff" }} />
                            </TableCell>
                            <TableCell className="th" align="center" style={{border:"1px solid #f0f0f0"}}>{t('message.common.subtitle.inspection.date')}</TableCell>
                            <TableCell className='td_print' align="center" style={{border:"1px solid #f0f0f0"}}>
                              <Controller
                                  control={control}
                                  name={"chkYmd"}
                                  render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                  <CustomDatePicker
                                      field={field} ref={ref} name={name} value={value} register={register} 
                                      setValue={setValue} fieldState={fieldState}
                                  />
                                  )}
                              />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <TableContainer style={{marginTop:"10px"}}>
                      <Table sx={{ minWidth: 1000, borderTop:"2px solid #9b9b9b" }} aria-label="simple table" className="list_table">
                        <TableHead>
                          <TableRow>
                            <TableCell className="th" align="center">{t('message.common.select.division')}</TableCell>
                            <TableCell className="th" align="center">{t('message.common.subtitle.inspection.item')}</TableCell>
                            <TableCell className="th" align="center">{t('message.common.subtitle.inspection.details')}</TableCell>
                            <TableCell className="th" align="center">{t('message.common.subtitle.inspection.result')}</TableCell>
                          </TableRow>   
                        </TableHead>
                        <TableBody>
                        {checkupItems && checkupItems.map(function(item, i) {
                          return(
                          <TableRow key={i}>
                            <TableCell className='td_print' align="center">{item.chkCycle && getEnumValueByEnumNameAndCode("CheckCycle", item.chkCycle) && getEnumValueByEnumNameAndCode("CheckCycle", item.chkCycle)[0].title}</TableCell>
                            <TableCell className='td_print1' align="center" style={{textAlign:"left"}}>{item.chkItemNm}</TableCell>
                            <TableCell className='td_print' style={{textAlign:"left"}}>- {item.chkItemDtlNm}</TableCell>
                            <TableCell align="center" className="radio td_print">
                              <FormControl component="fieldset"
                                >
                                <RadioGroup aria-labelledby="result" 
                                  value={radioValues[i] || ''}
                                  sx={{".MuiRadio-root":{"color":"#000"}}} 
                                  onChange={(event)=>{
                                    let radioValuesCopy = [...radioValues];
                                    radioValuesCopy[i] = event.target.value
                                    setRadioValues(radioValuesCopy);
                                  }}
                                  row>
                                  {getEnumValueByEnumName("CheckResult") && getEnumValueByEnumName("CheckResult").map(function(radioItem, j) {
                                    // console.log(radioItem)
                                    return (
                                      <FormControlLabel key={j} value={radioItem.code} control={<Radio />} label={radioItem.title} />
                                    )
                                  })}
                                </RadioGroup>
                              </FormControl>
                            </TableCell>
                          </TableRow>
                          )
                        })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    </div>
                  </form>
                  <div style={{display:"flex", justifyContent:"space-between"}}>
                    {(excelDatas2.length > 0) &&
                    // <div style={{textAlign:"right",marginRight:"5px"}}>
                      <EquipmentChecklistExcelDownload excelDatas1={excelDatas1} excelDatas2={excelDatas2} title={`${info?.name} ${t('message.common.title.maintenance.checklist')}`} filename={`${fileName}.xlsx`}/>
                    // </div>
                    }
                    
                    <div>
                      <Button className="apply_btn" variant="contained" onClick={handleSubmit(onSubmit)}>{t('message.common.btn.modify')}</Button>&nbsp;&nbsp;
                      <Button className="apply_btn" variant="contained" color='error' onClick={delBtnClick}>{t('message.common.btn.delete')}</Button>&nbsp;&nbsp;
                      <Button className="apply_btn" variant="contained" color='secondary' onClick={()=>{setCheckupId(null);setCheckCycle('')}}>{t('message.common.btn.cancel')}</Button>
                    </div>
                  </div>
                  </Col>
                  }
                  {/* 등록 */}
                  {!checkupId && 
                  <Col sm={8} style={{padding:"10px"}}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div style={{color:"red",fontWeight:"bold"}}>* {t('message.common.alert.division.select')}</div>
                    <div ref={ printRef }>
                    <TableContainer>
                      <Table sx={{ maxWidth: 770 }} aria-label="simple table" className='tab_checklist'>
                        <TableBody>
                          <TableRow style={{display:"flex", alignItems:"center"}}>
                            <TableCell className="th" style={{width:"100px"}} align="center">{t('message.common.select.division')}</TableCell>
                            <TableCell align="center">
                              <FormControl>
                                <CustomEnumSelect
                                  key={checkCycle}
                                  label={t('message.common.select.division')}
                                  labelName={t('message.common.select.division')}
                                  name={'chkCycle'}
                                  defaultValue={checkCycle}
                                  className='td_print'
                                  onChange={(e)=>{
                                    setCheckCycle(e.target.value);
                                    setIsLoading(false);
                                  }}
                                  list={getEnumValueByEnumName("CheckCycle")}
                                />
                              </FormControl>
                            </TableCell>
                            <TableCell className="th" style={{width:"100px"}}  align="center">{t('message.common.subtitle.fieldChkUser')}</TableCell>
                            <TableCell align="center">
                              <TextField id="outlined-basic" 
                                defaultValue={''}
                                {...register("chkUser", {
                                })} 
                              />
                            </TableCell>
                            <TableCell className="th" style={{width:"100px"}}  align="center">{t('message.common.subtitle.inspection.date')}</TableCell>
                            <TableCell align="center">
                              <Controller
                                  control={control}
                                  name={"chkYmd"}
                                  render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                  <CustomDatePicker
                                      field={field} ref={ref} name={name} value={value} register={register} 
                                      setValue={setValue} fieldState={fieldState}
                                  />
                                  )}
                              />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <TableContainer style={{marginTop:"10px"}}>
                      <Table sx={{ minWidth: 900, borderTop:"2px solid #9b9b9b" }} aria-label="simple table" className="list_table">
                        <TableHead>
                          <TableRow>
                            <TableCell className="th" align="center">{t('message.common.select.division')}</TableCell>
                            <TableCell className="th" align="center">{t('message.common.subtitle.inspection.item')}</TableCell>
                            <TableCell className="th" align="center">{t('message.common.subtitle.inspection.details')}</TableCell>
                            <TableCell className="th" align="center">{t('message.common.subtitle.inspection.result')}</TableCell>
                            <TableCell className="th" align="center">{t('message.common.subtitle.attach')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {checkupItems && checkupItems.map(function(item, i) {
                            // console.log(i,item);
                              return(
                          <TableRow key={i}>
                            <TableCell className='td_print' align="center">{item.chkCycle && getEnumValueByEnumNameAndCode("CheckCycle", item.chkCycle) && getEnumValueByEnumNameAndCode("CheckCycle", item.chkCycle)[0].title}</TableCell>
                            <TableCell className='td_print1' align="center" style={{textAlign:"left"}}>{item.chkItemNm}</TableCell>
                            <TableCell className='td_print equip_check_cont' style={{textAlign:"left"}}>- {item.chkItemDtlNm}</TableCell>
                            <TableCell align="center" className="radio td_print">
                              <FormControl component="fieldset">
                                <RadioGroup aria-labelledby="result" defaultValue={''}
                                  sx={{".MuiRadio-root":{"color":"#000"}}} 
                                  onChange={(event)=>{
                                    let radioValuesCopy = [...radioValues];
                                    radioValuesCopy[i] = event.target.value
                                    setRadioValues(radioValuesCopy);
                                  }}
                                  row>
                                  {getEnumValueByEnumName("CheckResult") && getEnumValueByEnumName("CheckResult").map(function(radioItem, j) {
                                    return (
                                      <FormControlLabel key={j} value={radioItem.code} control={<Radio />} label={radioItem.title} />
                                    )
                                  })}
                                </RadioGroup>
                              </FormControl>
                            </TableCell>
                            <TableCell align="center" className="noteicon td_print">
                              {item.manualFile && <PdfLayer file={item.manualFile} />}
                            </TableCell>
                          </TableRow>
                              )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    </div>
                    </form>

                    <div style={{display:"flex", justifyContent:"space-between", marginTop:"10px"}}>
                      <div></div>
                      { role !== ROLE.MO.code &&
                      <Button className="apply_btn" variant="contained" onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</Button>
                      }
                    </div>
                  </Col>
                  }
                  <Col sm={4} style={{padding:"10px"}}>
                    <div>
                      <p style={{margin:"0",textAlign:"center",color:"#262626",fontWeight:"600"}}>
                        <KeyboardArrowLeft fontSize="small" style={{cursor:"pointer"}} onClick={() => prevMove()} /> 
                        {curMonthStr} 
                        <KeyboardArrowRight fontSize="small" style={{cursor:"pointer"}} onClick={() => nextMove()} />
                      </p>
                      <TableContainer>
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.select.division')}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.inspection.date')}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {checkupResults && checkupResults.map(function(item, i) {
                              return(
                            <TableRow key={i} className='pop_tr'>
                              <TableCell align="center"><span style={{cursor:"pointer"}} onClick={()=>{setCheckupId(item.id)}}>{item.chkCycle && getEnumValueByEnumNameAndCode("CheckCycle", item.chkCycle) && getEnumValueByEnumNameAndCode("CheckCycle", item.chkCycle)[0].title}</span></TableCell>
                              <TableCell align="center"><span style={{cursor:"pointer"}} onClick={()=>{setCheckupId(item.id)}}>{item.chkYmd}</span></TableCell>
                            </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </Col>
                </Row>
            </CardContent>
          </MainCard>
        </Modal>
      </>
    )
}

export default EquipmentChecklistLayer;